import React from 'react'
import EarningsBody from './EarningsBody'
import MyEarningsCardHeader from './MyEarningsCardHeader'
import StyledCardMini from './StyledCardMini'

const EarningsCard: React.FC = () => {
  return (
    <StyledCardMini p={0} mb="24px">
      <MyEarningsCardHeader />
      <EarningsBody onDashboard />
    </StyledCardMini>
  )
}

export default EarningsCard
